<template>
  <div class="d-flex align-center ga-2">
    <CustomSwitchWrapper
      class="mb-2"
      data-test-id="allow-approver"
      :initial-value="Boolean(expertSettings)"
      :label="String(i18n.t('buttons.show_approver_action'))"
      label-class="drawer-subhead"
      :switch-id="i18n.t('buttons.show_approver_action')"
      @value-changed="toggleExpertSettings"
    >
    </CustomSwitchWrapper>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useExpertSettings } from '@/composables/useExpertSettings';
import CustomSwitchWrapper from '@/components/inputs/CustomSwitchWrapper.vue';

const i18n = useI18n();
const { expertSettings, toggleExpertSettings } = useExpertSettings();
</script>
